const React = require('react');

module.exports = (props) => (
  <svg width="6" height="10" fill="none" {...props} viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg">
    <path d="M-1.09278e-07 8.75L1.2228 10L6 5L1.2228 8.46774e-07L-7.64949e-07 1.25L3.6 5L-1.09278e-07 8.75Z" fill="#73757A"/>
  </svg>
);
